import { Product_Info } from '@/globalcfg.js';

const zhCN = {
    messages: {
      'number_particle': '颗粒数量',
      'quicklocate_tip': "温馨提示:点击下方图片，可以快速定位!",
      'build_detail_back': '上一步',
      'build_detail_next': '下一步',
      'main_products' : '产品',
      'main_Unique_title' : '像素艺术',
      'main_Unique_detail' : '将您的照片转化为永恒的杰作。艺术中的创意和多样性是无限的。在Amalia，每张图片都讲述着独特的故事，超越年龄。选择Amalia的像素艺术之旅，让每张图片都成为永恒的艺术之作。',

      'main_try_upload' : '立即尝试',
      'main_try_upload_detail' : '上传您的照片，创作属于您自己的像素艺术杰作！',


      'shop_on_amazon' : '亚马逊购买链接',
      'menu_about_us'  : '关于我们',
      'menu_home' : '首页',
      'menu_products' : '产品',
      'about_us_detail' : 'Amalia品牌的故事始于对独特艺术体验的执着探索。我们不仅追求产品，更追求在创意、时尚和多元文化融合中的冒险。从最初的灵感到产品巧妙设计，Amalia不懈地追求超越寻常的艺术之美。我们的使命是打破界限，为各年龄段的个体创造独特艺术空间。无论是将照片转化为像素艺术、钻石画，还是通过积木拼装成杰作，Amalia始终引领着创意潮流，使每一刻都成为永恒的艺术之作。选择Amalia，踏上独特的艺术之旅。',
      'about_us_title' : 'Amalia故事',

      'littlebrick_showname' : Product_Info.Origin.show_name_zh,
      'microbrick_showname' : Product_Info.MicroBrick.show_name_zh,
      'colorbrick_gray_showname' : Product_Info.Memory.show_name_zh,
      'colorbrick_orange_showname' : Product_Info.Energetic.show_name_zh,
      'colorbrick_pink_showname' : Product_Info.Fascinatic.show_name_zh,
      'fusebeads_showname' : Product_Info.FuseBeads.show_name_zh,
      'diamondpainting_showname' : Product_Info.DiamondPainting.show_name_zh,
      'romantic_showname' : Product_Info.Romantic.show_name_zh,
      'warmth_showname' : Product_Info.Warmth.show_name_zh,

      'use_granules' : '此幅画使用以下颗粒拼装:',

      // 产品详情页的介绍文字
      'littlebrick_introduction' : '使用50x50的底板和黑白灰三色积木块，以原始艺术为灵感，打造专属于你的独特马赛克肖像画！',
      'microbrick_introduction' : '4mm积木颗粒，拼出桌面艺术新风尚！',
      'colorbrick_gray_introduction' : '泛黄的黑白积木肖像画，勾起无限的回忆',
      'colorbrick_orange_introduction' : '红橙黄带给您无限能量',
      'colorbrick_pink_introduction' : '体验一副优雅、知性、闲适的肖像画，点缀你的生活空间',
      'fusebeads_introduction' : '简单熔珠，轻松卡通头像，激发无限创意！',
      'diamondpainting_introduction' : '丰富色彩、逼真细节、油画风格——让您的艺术作品独一无二',
      'romantic_introduction' : '一颗爱心、一抹彩虹、一对恋人，开启浪漫之旅',

      'product_part_titile' : '由以下部件拼装而成:',

    }
  }
  export default zhCN
  